import React from 'react';
import { Timeline, Upload, Table } from '@bedrock/components';
import type { TableProps } from '@bedrock/components/lib/table';
import moment from 'moment';
import { get } from 'lodash';
import './index.less';
import { priceFormat } from './util';
import { $sType } from '#utils';
import { adaptMpcExternalOuterPath } from '#utils/axios';

type AttachmentDtos = {
  id: number;
  blob?: {
    filename: string;
    byte_size: number;
    id: string;
    key: string;
    content_type: string;
  };
};

// 文件转换展示
export function renderFileList(params: {
  fileList: AttachmentDtos[];
  isInner?: boolean;
}) {
  const fileUrlMap = {
    inner: '/api/v2/java_proxy/attachments/',
    outer: adaptMpcExternalOuterPath(
      '/api/outsource/v2/java_proxy/attachments/'
    ),
  };
  if (!params?.fileList?.length) return '--';
  const { fileList, isInner } = params;
  const ableFileList = fileList.filter((item) => item.blob && item.id);
  if (!ableFileList?.length) return '--';
  const showList = ableFileList.map((item) => {
    return {
      uid: item.blob?.id,
      status: 'done',
      name: item.blob?.filename,
      url: `${fileUrlMap[$sType || 'inner']}${
        item.blob?.id || item.id
      }?download=attachment&isBlob=true`,
      size: item.blob?.byte_size,
    };
  });
  return (
    <Upload
      className={'file-list-readonly'}
      fileList={showList}
      fill
      size={'default'}
      readOnly
    />
  );
}
// 价格 展示
export function renderPrice({
  price,
  currency,
}: {
  price: number;
  currency: string;
}) {
  if (!price) return '--';
  return (
    <span className={'money'}>
      {priceFormat({
        price,
        currency,
      })}
    </span>
  );
}

export type ItemRender = {
  key: string;
  title: string;
  // 自定义渲染
  // value: 当前值
  // item: 当前行数据
  // index: 当前行索引
  // list: 所有数据
  render?: (
    value: any,
    item: any,
    index: number,
    list: any[]
  ) => string | JSX.Element;
};

// 默认渲染
const defaultRender = (value: string | null) => {
  return <span>{value || '--'}</span>;
};

export default function HistoryList({
  list = [],
  renderList = [],
  quoteTableProps,
}: {
  list: any[];
  renderList: ItemRender[];
  // 除data外的table属性
  quoteTableProps?: TableProps & { data: any[] };
}) {
  return (
    <div className={'sm-history-list'}>
      <Timeline className={'time-line'}>
        {list.map((item: any, index) => {
          return (
            <Timeline.Item
              key={index}
              title={`第 ${item.turns_number} 轮报价`}
              desc={
                moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') || '--'
              }
              status={index === 0 ? 'done' : 'default'}
            >
              {!!item.quote_list?.length && (
                <Table
                  className={'quate-table'}
                  {...quoteTableProps}
                  data={item.quote_list}
                />
              )}
              <table className={'table'}>
                <tbody>
                  {renderList.map((tr, tri) => {
                    const render = tr.render || defaultRender;
                    return (
                      <tr key={tri}>
                        <td className={'title'}>{tr.title}</td>
                        <td className={'value'}>
                          {render(
                            get(item, tr['key'], null),
                            item,
                            index,
                            list
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Timeline.Item>
          );
        })}
      </Timeline>
    </div>
  );
}
